import React, { useState, useEffect, useContext, useRef } from "react";
import { Alert, Box, Button, Stack, Paper, Grid } from '@mui/material';

import LoaderAnimation from "pages/LoaderAnimation";

import makeStyles from '@mui/styles/makeStyles';
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";

import { Line, Bar, getElementAtEvent, getDatasetAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS } from "chart.js/auto";
import { defaults } from "chart.js";
import { ChartColors } from "common/ChartColors";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import moment from "moment";
import AximDoughnut from "components/Content/Graphs/AximDoughnut";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    margin: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
    boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.05)",
  },
}));

function Dashboard() {
  const { companyId, acknowledgement } = useContext(PrivateRoutesContext);

  const [dashboardData, setDashboardData] = useState();

  const [chartData, setChartData] = useState();
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [details, setDetails] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (companyId) {
      getDashboards();
    }
  }, [companyId]);

  const getDashboards = () => {
    setIsLoading(true);
    setDetails(null);
    // apiGet(apiUrls.getDashboardCards(companyId)).then((response) => {
    //   // console.log(response.data);
    //   setDashboardData(response.data);

    //   if (response.data.charts) {
    //     setChartData(response.data.charts);
    //     // console.log(response.data.charts, "data");
    //   }
    //   setIsLoading(false);
    // });
    setIsLoading(false);
  };

  const handleClickChart = (chart, chartRef, event) => {
    var element = getElementAtEvent(chartRef.current, event);
    var dataset = getDatasetAtEvent(chartRef.current, event);

    // console.log(element, "element");
    // console.log(dataset, "dataset");

    if (element && element.length > 0 &&
      dataset && dataset.length > 0) {
        const datasetIndex = dataset[0].datasetIndex;

        var dataPoints = chart.dataSets[datasetIndex].dataPoints;

        // console.log(chart, "chart");

        if (dataPoints && dataPoints.length > 0 && chart.dataSets[datasetIndex].detailItemId) {
          // console.log(dataPoints[element[0].index], "dp");

          setIsLoadingDetails(true);
          apiGet(apiUrls.getDashboardItem(companyId, chart.dataSets[datasetIndex].detailItemId, moment(dataPoints[element[0].index].key).format("YYYY-MM-DD")))
            .then(response => {
              // console.log(response.data);

              response.data.details.sort((a,b) => b.value - a.value); // sort by value descending

              setDetails(response.data);
            })
            .catch(response => {
              setDetails(null);
            })
            .finally(() => {
              setIsLoadingDetails(false);
            })
        }
      }
  }

  return (
    <>
      {isLoading && <LoaderAnimation centerAtPage={true} />}
      {!isLoading ?
        <Stack direction="row" spacing={1} justifyContent="end" className="mb-2">
          {acknowledgement?.acknowledgements?.implementation?.documentId ? <Button variant="outlined" onClick={() => acknowledgement.setDoShowClientAcknowledgement(true)}>Implementation Acknowledgement</Button> : null}
        </Stack> : null
      }
      <Grid container >
        <Stack sx={{ width: '100%' }} spacing={1}>
            <Alert severity="warning" key={`dash-alert-x`}><b>dashboard information, e.g. files received, files uploaded</b></Alert>
        </Stack>
      </Grid>
      {!isLoading && dashboardData !== undefined ?
        <Grid container >
          <Stack sx={{ width: '100%' }} spacing={1}>
              <Alert severity="warning" key={`dash-alert-x`}><b>test</b></Alert>
            {dashboardData.reminders.map((prop, idx) => {
              return <Alert severity="warning" key={`dash-alert-${idx}`}><b>{prop}</b></Alert>
            })}
          </Stack>
        </Grid>
        : ""}
    </>
  );
}

export default Dashboard;
